/**
 * @file 检查是否为预览机环境（正常只有内部用户才会用到）
 * @auther tangyu04
 */
/* global App, getApp, swan */
import { request } from './request.js';
export const LVLIN_PREVIEW_ENV_RECORD = 'LvlinPreviewEnvRecord';

/**
 * 查询是否为预览机环境
 * @returns {Promise} 查询结果
 */

export const checkPreview = () => {
  return new Promise(resolve => {
    request({
      url: 'https://wen.baidu.com/wmis/preview/currentenv'
    }).then(res => {
      const data = res && res.data;
      resolve(!!(data && data.data && data.data.env));
    }).catch(() => {
      resolve(false);
    });
  });
};